var render = function (_h,_vm) {var _c=_vm._c;return _c('dl',_vm._b({class:[_vm.data.staticClass,_vm.data.class] || ''},'dl',_vm.data.$attrs,false),[_c('dt',[_vm._v(_vm._s(_vm.props.label))]),_c('dd',{staticClass:"truncate"},[_vm._v(_vm._s(_vm.props.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }